<object [data]="url"></object>